/* ==========================================================================
   Gadea Loreak — PDP (página de producto)
   Galería (thumbs + swipe + dots), selector de variantes, cantidad,
   acordeones, pestañas FAQ, carruseles, modal guía de tamaños y sticky ATC.
   Sin dependencias. Se auto-inicializa una vez por sección de producto.
   ========================================================================== */
(function () {
  'use strict';

  function euro(cents) {
    var n = (Number(cents) || 0) / 100;
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  /* Puente eliminado: iurop-cart.js escucha nativamente 'cart-drawer:open'
     y 'cart:updated' (con render desde detail.cart), asi que reenviar a
     'cart:open'/'cart:refresh' solo duplicaba fetches. */

  function initSection(root) {
    if (!root || root.__iuropPdpDone) return;
    root.__iuropPdpDone = true;

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* La barra sticky (#IuropStickyAtc) se renderiza FUERA de [data-pdp-root]
       (tras </section> en main-product.liquid), así que los selectores
       scopeados a root NO la ven: su stepper y su botón quedaban sin
       listeners (no añadía al carrito ni funcionaba el +/−). $$s() consulta
       root Y la barra sticky. Solo una sección la "adopta" (y solo si está
       fuera de root) para no duplicar listeners. */
    var stickyBar = document.getElementById('IuropStickyAtc');
    if (stickyBar && (root.contains(stickyBar) || stickyBar.__iuropPdpBound)) stickyBar = null;
    if (stickyBar) stickyBar.__iuropPdpBound = true;
    function $$s(sel) {
      var arr = $$(sel);
      if (stickyBar) arr = arr.concat(Array.prototype.slice.call(stickyBar.querySelectorAll(sel)));
      return arr;
    }

    /* ================= Galería ================= */
    var stage = $('[data-pdp-stage]');
    var slides = $$('[data-pdp-slide]');
    var thumbs = $$('[data-pdp-thumb]');
    var dots = $$('[data-pdp-dot]');

    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function goTo(index, smooth) {
      if (!stage || !slides[index]) return;
      stage.scrollTo({ left: slides[index].offsetLeft - stage.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(index);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    // sincroniza el punto/thumb activo al hacer swipe
    if (stage && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var idx = slides.indexOf(e.target);
            if (idx > -1) setActive(idx);
          }
        });
      }, { root: stage, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    function goToMedia(mediaId) {
      if (mediaId == null) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i); return; }
      }
    }

    /* ===== Miniatura de la barra sticky sincronizada con la variante =========
       Queja QA: "no cambia la imagen de add to cart". El <img> del sticky se
       renderiza en servidor con product.featured_media y se quedaba congelado.
       El JSON data-pdp-variants solo trae media_id, así que la URL se saca del
       DOM: la miniatura de la galería (180w, el tamaño que necesita el sticky)
       y, si el producto tiene una sola foto y no hay miniaturas, del slide. */
    var satcEl = document.getElementById('IuropStickyAtc');
    var satcThumb = satcEl ? satcEl.querySelector('.iurop-satc__thumb img') : null;
    function srcForMedia(mediaId) {
      if (mediaId == null) return '';
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) !== String(mediaId)) continue;
        var th = thumbs[i] ? thumbs[i].querySelector('img') : null;
        if (th) return th.getAttribute('src') || th.src;
        var im = slides[i].querySelector('img');
        return im ? (im.getAttribute('src') || im.src) : '';
      }
      return '';
    }
    function updateStickyThumb(v) {
      if (!satcThumb || !v) return;
      var s = srcForMedia(v.media_id);
      if (!s || satcThumb.getAttribute('src') === s) return;
      satcThumb.removeAttribute('srcset');
      satcThumb.setAttribute('src', s);
    }

    /* ================= Lightbox (galería a pantalla completa) ================= */
    var lb = document.querySelector('[data-pdp-lightbox]');
    if (lb) {
      // Muévelo a <body> para que 'position:fixed' no quede atrapado por un
      // stacking context de la sección (isolation/transform/sticky) y limpia
      // cualquier duplicado que deje un re-render del editor.
      Array.prototype.slice.call(document.querySelectorAll('body > [data-pdp-lightbox]'))
        .forEach(function (old) { if (old !== lb) old.remove(); });
      if (lb.parentNode !== document.body) document.body.appendChild(lb);

      var lbTrack = lb.querySelector('[data-lb-track]');
      var lbSlides = Array.prototype.slice.call(lb.querySelectorAll('[data-lb-slide]'));
      var lbPrev = lb.querySelector('[data-lb-prev]');
      var lbNext = lb.querySelector('[data-lb-next]');
      var lbCurrent = lb.querySelector('[data-lb-current]');
      var lbClose = lb.querySelector('.iurop-lb__close');
      var lbIndex = 0;
      var lbLastFocus = null;

      function lbGo(i, smooth) {
        if (!lbSlides.length) return;
        if (i < 0) i = lbSlides.length - 1;
        if (i >= lbSlides.length) i = 0;
        lbIndex = i;
        if (lbTrack && lbSlides[i]) {
          lbTrack.scrollTo({ left: lbSlides[i].offsetLeft - lbTrack.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
        }
        if (lbCurrent) lbCurrent.textContent = i + 1;
      }
      function lbOpen(i) {
        lbLastFocus = document.activeElement;
        lb.hidden = false;
        void lb.offsetWidth;
        lb.classList.add('is-open');
        document.documentElement.classList.add('iurop-cd-locked');
        lbGo(i || 0, false);
        if (lbClose && lbClose.focus) lbClose.focus();
      }
      function lbHide() {
        lb.classList.remove('is-open');
        document.documentElement.classList.remove('iurop-cd-locked');
        setTimeout(function () { if (!lb.classList.contains('is-open')) lb.hidden = true; }, 260);
        if (lbLastFocus && lbLastFocus.focus) { try { lbLastFocus.focus(); } catch (e) {} }
      }

      // Abrir al hacer click en la imagen del hero (galería principal).
      slides.forEach(function (s, i) {
        var img = s.querySelector('img');
        if (img) img.addEventListener('click', function () { lbOpen(i); });
      });

      if (lbPrev) lbPrev.addEventListener('click', function () { lbGo(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbGo(lbIndex + 1); });

      // Cerrar: X o backdrop (cualquier [data-lb-close]); clic sobre la imagen NO cierra.
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) lbHide();
      });

      // Teclado: Esc cierra, flechas navegan.
      document.addEventListener('keydown', function (e) {
        if (lb.hidden || !lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); lbHide(); }
        else if (e.key === 'ArrowLeft') { lbGo(lbIndex - 1); }
        else if (e.key === 'ArrowRight') { lbGo(lbIndex + 1); }
      });

      // Sincroniza el contador al hacer swipe.
      if (lbTrack && lbSlides.length > 1) {
        var lbScrollT;
        lbTrack.addEventListener('scroll', function () {
          clearTimeout(lbScrollT);
          lbScrollT = setTimeout(function () {
            var w = lbSlides[0] ? lbSlides[0].getBoundingClientRect().width : lbTrack.clientWidth;
            var idx = Math.round(lbTrack.scrollLeft / (w || 1));
            if (idx !== lbIndex && lbSlides[idx]) { lbIndex = idx; if (lbCurrent) lbCurrent.textContent = idx + 1; }
          }, 80);
        }, { passive: true });
      }
    }

    /* ================= Cantidad ================= */
    function bindStepper(scope) {
      $$('[data-pdp-qty-wrap]', scope).forEach(function (wrap) {
        var input = $('[data-pdp-qty]', wrap);
        if (!input) return;
        var minus = $('[data-pdp-qty-minus]', wrap);
        var plus = $('[data-pdp-qty-plus]', wrap);
        if (minus) minus.addEventListener('click', function () { setQty(parseInt(input.value, 10) - 1); });
        if (plus) plus.addEventListener('click', function () { setQty(parseInt(input.value, 10) + 1); });
        input.addEventListener('change', function () { setQty(parseInt(input.value, 10)); });
      });
    }
    function setQty(v) {
      if (isNaN(v) || v < 1) v = 1;
      $$s('[data-pdp-qty]').forEach(function (i) { i.value = v; });
    }
    bindStepper(root);
    if (stickyBar) bindStepper(stickyBar);

    /* ================= Variantes ================= */
    var form = $('.iurop-pdp__form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var variants = [];
    try { variants = JSON.parse($('[data-pdp-variants]').textContent); } catch (e) { variants = []; }

    var priceEl = $('[data-pdp-price]');
    var compareEl = $('[data-pdp-compare]');

    /* ===== Mensaje de stock sincronizado con la variante seleccionada =====
       El <p data-pdp-stock> se renderiza en servidor desde
       product.selected_or_first_available_variant, que en un producto
       multi-variante puede ser OTRA variante (la primera DISPONIBLE) distinta
       de la que muestra el selector → "¡Últimas unidades!" mientras el ATC
       dice "No disponible". updateStock() lo recalcula con la variante REAL. */
    var stockEl = $('[data-pdp-stock]');
    /* Las etiquetas son ajustes de sección para que la PDP de un TALLER pueda
       decir "Plazas disponibles / ¡Últimas plazas! / Completo". Si el JS no las
       leyera, al cambiar de variante revertiría al texto de flores. */
    var stockCfg = {
      low_thr: 2,
      delivery: '',
      show_pickup: false,
      stock_text: 'En stock',
      low_text: '¡Últimas unidades!',
      out_text: 'Agotado',
      pickup_text: 'recógelo en tienda',
      unavail_text: 'No disponible',
      /* Entrega dinámica (QA17): regla nueva de envíos — antes de la hora de
         corte el pedido llega el siguiente día laborable (lead_before=1);
         después, dos (lead_after=2). Mismos valores que el calendario del
         carrito. Los textos son ajustes de la sección; estos son su espejo. */
      show_delivery: false,
      delivery_auto: false,
      cutoff_hour: 12,
      lead_before: 1,
      lead_after: 2,
      cutoff_before_text: 'Pídelo antes de {contador} y recíbelo el {fecha}'
    };
    try {
      var cfgNode = $('[data-pdp-stock-config]');
      if (cfgNode) {
        var parsed = JSON.parse(cfgNode.textContent);
        if (parsed && typeof parsed === 'object') {
          if (parsed.low_thr != null) stockCfg.low_thr = Number(parsed.low_thr) || 0;
          if (parsed.delivery != null) stockCfg.delivery = String(parsed.delivery);
          stockCfg.show_pickup = !!parsed.show_pickup;
          stockCfg.show_delivery = !!parsed.show_delivery;
          stockCfg.delivery_auto = !!parsed.delivery_auto;
          if (parsed.cutoff_hour != null && !isNaN(Number(parsed.cutoff_hour))) stockCfg.cutoff_hour = Number(parsed.cutoff_hour);
          if (parsed.lead_before != null && Number(parsed.lead_before) > 0) stockCfg.lead_before = Number(parsed.lead_before);
          if (parsed.lead_after != null && Number(parsed.lead_after) > 0) stockCfg.lead_after = Number(parsed.lead_after);
          ['stock_text', 'low_text', 'out_text', 'pickup_text', 'unavail_text', 'cutoff_before_text'].forEach(function (k) {
            if (parsed[k] != null && String(parsed[k]) !== '') stockCfg[k] = String(parsed[k]);
          });
        }
      }
    } catch (e) {}
    /* Plantilla del texto de entrega tal y como llegó del servidor: si el
       comerciante escribió uno propio con la marca de fecha, cada refresco
       parte de la plantilla (no del texto ya sustituido). */
    var deliveryTpl = stockCfg.delivery;
    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function pickupBtn() {
      return stockCfg.show_pickup
        ? ' o <button type="button" class="iurop-pdp__pickup" data-pdp-pickup-toggle>' + esc(stockCfg.pickup_text) + '</button>'
        : '';
    }
    /* La línea de entrega puede venir VACÍA (talleres apagan la fecha) → el
       separador solo se emite si hay texto, igual que hace el Liquid. */
    function deliveryPart() {
      return stockCfg.delivery ? ' · ' + stockCfg.delivery : '';
    }

    /* ===== Entrega dinámica (QA17) ============================================
       La fecha del «Recíbelo el X» se renderiza en SERVIDOR: la CDN cachea el
       HTML (puede quedar obsoleta) y no sabe la hora del visitante. Aquí se
       RECALCULA con el reloj local y la MISMA regla nueva que el calendario
       del carrito: antes de la hora de corte → siguiente día laborable;
       después → dos, saltando findes y festivos nacionales ES (9 fijos +
       Viernes Santo = Domingo de Pascua − 2, algoritmo gregoriano anónimo;
       cálculo portado compacto de iurop-cart.js). */
    /* Meses y formato de fecha por idioma del documento (fr «1 août»,
       pt «1 de agosto», es «1 de agosto»): la tienda sirve /fr y /pt y una
       fecha en español ahí canta. */
    var LANG = (document.documentElement.lang || 'es').slice(0, 2);
    var MESES_I18N = {
      es: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      fr: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
      pt: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
    };
    var MESES = MESES_I18N[LANG] || MESES_I18N.es;
    function fmtFecha(d) {
      if (LANG === 'fr') return d.getDate() + ' ' + MESES[d.getMonth()];
      return d.getDate() + ' de ' + MESES[d.getMonth()];
    }
    var RECIBELO = LANG === 'fr' ? 'Recevez-le le ' : (LANG === 'pt' ? 'Receba-o no dia ' : 'Recíbelo el ');
    function isoDate(d) {
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }
    var natCache = {};
    function natHolidays(y) {
      if (natCache[y]) return natCache[y];
      var set = {};
      ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'].forEach(function (md) { set[y + '-' + md] = 1; });
      var a = y % 19, b = Math.floor(y / 100), c = y % 100, dd = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - dd - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, mm = Math.floor((a + 11 * h + 22 * l) / 451),
        mo = Math.floor((h + l - 7 * mm + 114) / 31), da = ((h + l - 7 * mm + 114) % 31) + 1;
      var gf = new Date(y, mo - 1, da); gf.setDate(gf.getDate() - 2);
      set[isoDate(gf)] = 1;
      natCache[y] = set;
      return set;
    }
    function isBlockedDay(d) {
      var w = d.getDay();
      return w === 0 || w === 6 || !!natHolidays(d.getFullYear())[isoDate(d)];
    }
    function deliveryEstimate(now) {
      now = now || new Date();
      /* La hora de corte solo existe en días LABORABLES: un pedido de
         sábado, domingo o festivo cuenta como pedido del siguiente laborable
         a primera hora (antes del corte). Sin esto, el sábado por la mañana
         prometía entrega al día laborable siguiente como si se preparase
         en finde (QA: no contar sábados y domingos como laborables). */
      var eff = new Date(now);
      while (isBlockedDay(eff)) { eff.setDate(eff.getDate() + 1); eff.setHours(0, 0, 0, 0); }
      var before = eff.getHours() < stockCfg.cutoff_hour;
      var lead = before ? stockCfg.lead_before : stockCfg.lead_after;
      var d = new Date(eff); d.setHours(0, 0, 0, 0);
      while (lead > 0) { d.setDate(d.getDate() + 1); if (!isBlockedDay(d)) lead--; }
      var tom = new Date(now); tom.setHours(0, 0, 0, 0); tom.setDate(tom.getDate() + 1);
      return {
        date: d,
        before: before,
        isTomorrow: d.getTime() === tom.getTime(),
        fecha: fmtFecha(d)
      };
    }
    /* Sincroniza el «Recíbelo el X» de la línea de stock con la fecha
       recalculada: con el texto automático se reconstruye entero (mismo
       prefijo que hornea el Liquid); con texto propio del comerciante solo
       se sustituye la marca de fecha si la usa. */
    function refreshDeliveryText() {
      if (!stockCfg.show_delivery || !stockCfg.delivery) return;
      var est = deliveryEstimate();
      if (stockCfg.delivery_auto) stockCfg.delivery = RECIBELO + est.fecha;
      else if (deliveryTpl.indexOf('{fecha}') > -1) stockCfg.delivery = deliveryTpl.replace('{fecha}', est.fecha);
    }
    /* Mini-apartado bajo la línea de stock: solo con stock y entrega activa. */
    var cutoffEl = $('[data-pdp-cutoff]');
    var cutoffTextEl = cutoffEl ? cutoffEl.querySelector('[data-pdp-cutoff-text]') : null;
    /* Cuenta atrás viva hasta la hora de corte («pide antes de 1 h 23 min»),
       para crear urgencia (petición QA). {contador} se re-pinta cada 30 s en
       NEGRITA (el <strong> hereda el coral del aviso); al cruzar el corte el
       texto salta solo a la variante «después». */
    function fmtContador(ms) {
      var min = Math.max(1, Math.ceil(ms / 60000));
      var h = Math.floor(min / 60), m = min % 60;
      /* Con el corte en el próximo laborable, el finde el contador supera
         las 24h: "2 d 21 h" se lee mejor que "69 h 49 min". */
      if (h >= 24) {
        var dd = Math.floor(h / 24), dLbl = LANG === 'fr' ? 'j' : 'd';
        return dd + ' ' + dLbl + ' ' + (h % 24) + ' h';
      }
      if (h > 0) return h + ' h ' + (m < 10 ? '0' : '') + m + ' min';
      return m + ' min';
    }
    var cutoffTimer = null;
    var cutoffState = 'in';
    /* Contador SIEMPRE visible (petición QA): cuenta hasta el PRÓXIMO corte —
       las 12:00 de hoy si aún no han pasado, o las de mañana si ya pasaron — y
       la fecha es la de entrega SI PIDES ANTES de ese corte (estimación a
       target−1min), no la de pedir ahora. Así después de las 12 sigue habiendo
       urgencia real: «Pídelo antes de 19 h 04 min y recíbelo el 3 de agosto». */
    function nextCutoff(now) {
      var t = new Date(now); t.setHours(stockCfg.cutoff_hour, 0, 0, 0);
      if (now.getTime() >= t.getTime()) t.setDate(t.getDate() + 1);
      /* El próximo corte cae siempre en día LABORABLE: el viernes por la
         tarde el corte que importa es el del lunes, no "mañana sábado"
         (prometía una fecha imposible que contradecía al «Recíbelo el X»). */
      while (isBlockedDay(t)) t.setDate(t.getDate() + 1);
      return t;
    }
    function updateCutoff(state) {
      if (!cutoffEl) return;
      cutoffState = state;
      if (!stockCfg.show_delivery || state === 'out') { cutoffEl.hidden = true; return; }
      var now = new Date();
      var target = nextCutoff(now);
      var est = deliveryEstimate(new Date(target.getTime() - 60000));
      var contador = '<strong>' + fmtContador(target.getTime() - now.getTime()) + '</strong>';
      var txt = stockCfg.cutoff_before_text;
      if (cutoffTextEl) cutoffTextEl.innerHTML = esc(txt).replace('{contador}', contador).replace('{fecha}', esc(est.fecha));
      cutoffEl.hidden = false;
      if (!cutoffTimer) cutoffTimer = setInterval(function () { updateCutoff(cutoffState); refreshDeliveryText(); }, 30000);
    }

    function updateStock(v) {
      var state = 'out';
      if (v && v.available) {
        state = 'in';
        if (v.managed && typeof v.inv === 'number' && v.inv > 0 && v.inv <= stockCfg.low_thr) state = 'low';
      }
      updateCutoff(state);
      if (!stockEl) return;
      refreshDeliveryText();
      if (state === 'in') {
        stockEl.innerHTML = '<span class="iurop-pdp__dot-stock"></span><span><strong>' + esc(stockCfg.stock_text) + '</strong>' + deliveryPart() + pickupBtn() + '</span>';
      } else if (state === 'low') {
        stockEl.innerHTML = '<span class="iurop-pdp__dot-stock is-low"></span><span><strong>' + esc(stockCfg.low_text) + '</strong>' + deliveryPart() + pickupBtn() + '</span>';
      } else {
        stockEl.innerHTML = '<span class="iurop-pdp__dot-stock is-out"></span><span><strong>' + esc(stockCfg.out_text) + '</strong></span>';
      }
      /* Aviso de reposición: el botón solo existe si la variante está agotada.
         Se le pasa el título de la variante para que el email diga cuál. */
      $$('[data-notify-open]').forEach(function (b) {
        b.hidden = state !== 'out';
        if (v && v.options) b.setAttribute('data-notify-variant', v.options.join(' / '));
      });
    }

    /* Una opción puede pintarse como PÍLDORAS (radios) o, cuando tiene más
       valores que settings.variant_select_threshold (las ~28 letras de "Letra
       personalizable con peana"), como DESPLEGABLE. Los dos llevan el mismo
       data-pdp-option (índice 1-based); el desplegable añade
       data-pdp-option-select y lo lleva EL PROPIO <select>, así que el
       querySelectorAll devuelve también el contenedor: se lee el valor del que
       lo tenga y nunca se pisa con undefined. */
    function optionValue(el) {
      if (el.tagName === 'SELECT') return el.value;
      var checked = el.querySelector('input:checked');
      if (checked) return checked.value;
      var sel = el.querySelector('[data-pdp-option-select]');
      return sel ? sel.value : null;
    }
    function currentSelection() {
      var opts = [];
      $$('[data-pdp-option]').forEach(function (fieldset) {
        var pos = parseInt(fieldset.getAttribute('data-pdp-option'), 10);
        if (!pos) return;
        var val = optionValue(fieldset);
        if (val != null && val !== '') opts[pos - 1] = val;
      });
      return opts;
    }
    function findVariant(opts) {
      if (!variants.length) return null;
      // Producto de variante ÚNICA: no hay fieldsets [data-pdp-option] → currentSelection()
      // devuelve [] y el match por opciones fallaría (opts[i] undefined) marcando el ATC como
      // "No disponible" aunque el producto esté a la venta. Casa por el id del form (la
      // variante server-selected) o la primera variante.
      if (!$('[data-pdp-option]')) {
        var id = idInput && idInput.value;
        return variants.filter(function (v) { return String(v.id) === String(id); })[0] || variants[0];
      }
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function updateVariant() {
      var v = findVariant(currentSelection());
      if (!v) {
        $$s('[data-pdp-add]').forEach(function (btn) {
          btn.disabled = true;
          var label = btn.querySelector('[data-pdp-add-label]');
          if (label) label.textContent = stockCfg.unavail_text;
        });
        updateStock(null);
        return;
      }
      if (idInput) idInput.value = v.id;

      // precio principal
      if (priceEl) priceEl.textContent = euro(v.price).replace(' ', '');
      if (compareEl) {
        if (v.compare_at && v.compare_at > v.price) {
          compareEl.textContent = euro(v.compare_at).replace(' ', '');
          compareEl.hidden = false;
          if (priceEl) priceEl.classList.add('is-sale');
        } else {
          compareEl.hidden = true;
          if (priceEl) priceEl.classList.remove('is-sale');
        }
      }

      // botones (principal + sticky) con precio
      $$s('[data-pdp-add]').forEach(function (btn) {
        var label = btn.querySelector('[data-pdp-add-label]');
        btn.disabled = !v.available;
        var base = btn.getAttribute('data-label-base') || 'Añadir al carrito';
        if (label) {
          if (!v.available) label.textContent = stockCfg.out_text;
          else if (btn.hasAttribute('data-with-price')) label.textContent = base + ' · ' + euro(v.price);
          else label.textContent = base;
        }
      });

      // mensaje de stock sincronizado con la variante seleccionada
      updateStock(v);

      // galería a la media de la variante
      if (v.media_id != null) goToMedia(v.media_id);

      // miniatura de la barra sticky a la media de la variante
      updateStickyThumb(v);
    }

    function syncPillClasses() {
      $$s('[data-pdp-option] label').forEach(function (lab) {
        var inp = lab.querySelector('input');
        lab.classList.toggle('is-selected', !!(inp && inp.checked));
      });
    }
    /* Sincronización bidireccional PDP <-> sticky por posición+valor. Cubre las
       DOS formas del selector: radios (píldoras) y <select> (opción con muchos
       valores). Elegir en el sticky actualiza la PDP y al revés, sea cual sea
       la forma de cada lado. */
    function setOption(pos, val) {
      $$s('[data-pdp-option="' + pos + '"] input').forEach(function (other) {
        other.checked = other.value === val;
      });
      $$s('select[data-pdp-option="' + pos + '"]').forEach(function (sel) {
        if (sel.value !== val) sel.value = val;
      });
      syncPillClasses();
      syncDropdowns();
      updateVariant();
    }
    $$s('[data-pdp-option] input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var wrap = inp.closest('[data-pdp-option]');
        if (!wrap) return;
        setOption(wrap.getAttribute('data-pdp-option'), inp.value);
      });
    });
    $$s('[data-pdp-option-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var wrap = sel.hasAttribute('data-pdp-option') ? sel : sel.closest('[data-pdp-option]');
        if (!wrap) return;
        setOption(wrap.getAttribute('data-pdp-option'), sel.value);
      });
    });

    /* ===== Desplegable propio (details) sobre el select de opciones =====
       El select oculto sigue siendo el portador de estado: los botones del
       panel solo escriben su value y disparan change, así el motor de
       variantes y la sincronización PDP-sticky no cambian de contrato.
       syncDropdowns() refresca el texto del summary y la píldora .is-selected
       y se llama también desde setOption para reflejar cambios que vengan
       del OTRO selector (PDP-sticky en los dos sentidos). */
    /* "Corazón" (y sus traducciones del admin) se pinta como corazón SVG con
       fill=currentColor — hereda el color de las letras. Espejo del snippet
       Liquid iurop-dd-label; el VALUE del select no cambia. */
    function ddIsHeart(v) {
      v = String(v || '').toLowerCase();
      return v === 'corazón' || v === 'cœur' || v === 'coeur' || v === 'coração';
    }
    var DD_HEART_SVG = '<svg class="iurop-dd__heart" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    function syncDropdowns() {
      $$s('[data-pdp-dd-wrap]').forEach(function (wrap) {
        var sel = wrap.querySelector('[data-pdp-option-select]');
        var dd = wrap.querySelector('[data-pdp-dd]');
        if (!sel || !dd) return;
        var cur = dd.querySelector('[data-dd-current]');
        if (cur) {
          if (ddIsHeart(sel.value)) {
            if (!cur.querySelector('.iurop-dd__heart')) cur.innerHTML = DD_HEART_SVG;
          } else if (cur.textContent !== sel.value) {
            cur.textContent = sel.value;
          }
        }
        Array.prototype.slice.call(dd.querySelectorAll('[data-dd-value]')).forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-dd-value') === sel.value);
        });
      });
    }
    $$s('[data-pdp-dd-wrap]').forEach(function (wrap) {
      var sel = wrap.querySelector('[data-pdp-option-select]');
      var dd = wrap.querySelector('[data-pdp-dd]');
      if (!sel || !dd) return;
      dd.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dd-value]');
        if (!btn) return;
        e.preventDefault();
        var val = btn.getAttribute('data-dd-value');
        if (sel.value !== val) {
          sel.value = val;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          syncDropdowns();
        }
        dd.removeAttribute('open');
      });
      /* cambios que lleguen por el change del propio select */
      sel.addEventListener('change', syncDropdowns);
    });
    /* clic fuera y Escape cierran cualquier panel abierto (una vez por página) */
    if (!document.__iuropDdGlobal) {
      document.__iuropDdGlobal = true;
      document.addEventListener('click', function (e) {
        Array.prototype.slice.call(document.querySelectorAll('[data-pdp-dd][open]')).forEach(function (dd) {
          if (!dd.contains(e.target)) dd.removeAttribute('open');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        Array.prototype.slice.call(document.querySelectorAll('[data-pdp-dd][open]')).forEach(function (dd) {
          dd.removeAttribute('open');
        });
      });
    }
    syncDropdowns();

    syncPillClasses();
    updateVariant();

    /* ================= Sticky ATC: botón reenvía al form principal =========
       (iurop-cart.js intercepta el submit en captura y hace el POST AJAX a
       /cart/add.js con FormData(form): id y quantity ya sincronizados). */
    $$s('[data-pdp-sticky-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    });

    /* ================= Acordeones (info + FAQ) ================= */
    $$('[data-pdp-acc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-pdp-acc]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = item.querySelector('[data-pdp-acc-panel]');
        if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';
      });
    });

    /* ================= Pestañas FAQ ================= */
    var tabs = $$('[data-pdp-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-pdp-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        $$('[data-pdp-faq-item]').forEach(function (it) {
          var match = it.getAttribute('data-tab') === name;
          it.hidden = !match;
          if (!match) { it.classList.remove('is-open'); var p = it.querySelector('[data-pdp-acc-panel]'); if (p) p.style.maxHeight = ''; }
        });
      });
    });

    /* ================= Carruseles (relacionados + reseñas) ============= */
    $$('[data-pdp-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-pdp-track]');
      var prev = car.querySelector('[data-pdp-prev]');
      var next = car.querySelector('[data-pdp-next]');
      if (!track) return;
      function step() {
        var first = track.querySelector(':scope > *');
        return first ? first.getBoundingClientRect().width + 16 : 320;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      /* Regla iUROP: flecha izquierda oculta en el origen, derecha oculta al final */
      function updArrows() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
      }
      track.addEventListener('scroll', updArrows, { passive: true });
      window.addEventListener('resize', updArrows);
      updArrows();
    });

    /* El CTA propio "Escribir reseña" se retiró (QA 28-jul): el widget de
       Judge.me ya trae su propio enlace para escribir reseña. */

    /* ================= Modal guía de tamaños ================= */
    var modal = document.getElementById('IuropSizeGuide');
    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.documentElement.classList.add('iurop-cd-locked');
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('iurop-cd-locked');
      setTimeout(function () { if (!modal.classList.contains('is-open')) modal.hidden = true; }, 260);
    }
    $$('[data-pdp-size-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openModal(); }); });
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-pdp-size-close]') || e.target.classList.contains('iurop-sg__overlay')) closeModal();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
    }

    /* ================= Recogida en tienda (toggle) ================= */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pdp-pickup-toggle]');
      if (!t) return;
      e.preventDefault();
      var panel = document.querySelector('[data-pdp-pickup-panel]');
      if (panel) panel.hidden = !panel.hidden;
    });

    /* ================= Sticky ATC (IntersectionObserver) ================= */
    var sticky = document.getElementById('IuropStickyAtc');
    var mainAtc = $('[data-pdp-atc-anchor]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var atcOut = false;
      var footerInView = false;
      function syncSticky() {
        var show = atcOut && !footerInView;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('iurop-has-sticky-atc', show);
        /* La barra nace con aria-hidden="true" (fuera de pantalla). Ahora puede
           contener un <select> de variante, y un control ENFOCABLE dentro de un
           aria-hidden es un fallo de accesibilidad: se libera al mostrarla. */
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // muestra la barra SIEMPRE que el ATC principal no esté en pantalla
          // (salido por arriba o aún por debajo, p.ej. sobre las imágenes)
          atcOut = !en.isIntersecting;
        });
        syncSticky();
      }, { threshold: 0 });
      sio.observe(mainAtc);
      // nunca sobre el footer: ocultar mientras el footer sea visible
      var footerEl = document.querySelector('.iurop-footer') || document.querySelector('footer');
      if (footerEl) {
        var fio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footerInView = en.isIntersecting; });
          syncSticky();
        }, { threshold: 0 });
        fio.observe(footerEl);
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-pdp-root]').forEach(initSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pdp-root]');
    if (r) initSection(r);
  });
})();
